import React from 'react'
import assets from '../utils/assets';
import styles from "../pages/pages.module.scss";


const HillGraph = () => {
  return (
    <img src={assets.hillgraph} alt='' className={`img-fluid ${styles.mHeight194}`} />
  )
}

export default HillGraph;